module.exports = __webpack_public_path__ + "img/1573591485.9ead8673.jpg";